import K1Router from "./K1.router";

export default K1Router;
